module.exports = __webpack_public_path__ + "static/media/ABI.c3685454.png";